/* bm_peakExplorer_locationControl.js - geolocation control for Mapbox */
(() => {
  'use strict';

  function bm_peakExplorer_attachLocationControl({ map, onActivate }) {
    if (!map || typeof map.addControl !== 'function' || typeof onActivate !== 'function') {
      return null;
    }

    let button = null;
    let container = null;
    let isRemoved = false;
    let isPending = false;
    let isDisabled = false;

    const handleClick = () => onActivate();
    const syncButtonState = () => {
      if (!button) return;
      button.disabled = isPending || isDisabled;
      button.setAttribute('aria-busy', String(isPending));
      button.setAttribute('aria-disabled', String(isDisabled));
      button.title = isPending
        ? 'Standort wird ermittelt'
        : isDisabled
          ? 'Koordinaten sind gesperrt'
          : 'Meinen Standort verwenden';
    };
    const control = {
      onAdd() {
        container = document.createElement('div');
        container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group bm-location-control';

        button = document.createElement('button');
        button.type = 'button';
        button.dataset.role = 'use-location';
        button.className = 'bm-location-control-button';
        button.setAttribute('aria-label', 'Meinen Standort verwenden');
        button.title = 'Meinen Standort verwenden';
        const mapContainerId = map.getContainer?.()?.id;
        if (mapContainerId) button.setAttribute('aria-controls', mapContainerId);

        const icon = document.createElement('span');
        icon.className = 'bm-location-control-icon';
        icon.setAttribute('aria-hidden', 'true');
        button.appendChild(icon);
        button.addEventListener('click', handleClick);
        container.appendChild(button);
        return container;
      },
      onRemove() {
        button?.removeEventListener('click', handleClick);
        container?.remove();
        container = null;
        isRemoved = true;
      }
    };

    map.addControl(control, 'top-right');
    if (!button) return null;

    return {
      button,
      setPending(nextPending) {
        isPending = Boolean(nextPending);
        syncButtonState();
      },
      setDisabled(nextDisabled) {
        isDisabled = Boolean(nextDisabled);
        syncButtonState();
      },
      destroy() {
        if (isRemoved) return;
        if (typeof map.removeControl === 'function') {
          map.removeControl(control);
        }
      }
    };
  }

  window.BM = window.BM || {};
  window.BM.bm_peakExplorer_attachLocationControl =
    bm_peakExplorer_attachLocationControl;
})();
